module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epigraph#epig",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#prol"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Gilded Age: A Tale of Yesterday")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("The Cosmopolitan Standard of Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Shudder of Fascination")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Certain Sensuous Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Read Gertrude Stein")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Defense of Bad Taste")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What One Is Forced by Nature to Do")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Entirely New Kind of Negro")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exotic Material")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cruel Sophistication")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quite Gay, but Empty, Bubble That Dazzles One in Bursting")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Papa Woojums")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yale May Not Think So, but It’ll Be Just Jolly")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Attention That I Used to Get")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/illust_credits#illust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0